import axios, { AxiosError } from "axios";
import React, { createContext, useContext, useEffect, useState } from "react";
import { distributionUrl } from "../components/Config/url";
import { useAxiosConfigGlobal } from "../components/Config/axios";
import { useCookies } from "react-cookie";
import { useNavigate, useSearchParams } from "react-router-dom";

const ContractContext = createContext();

export const useContract = () => {
  return useContext(ContractContext);
};

const maxStep = 5;

export const ContractProvider = ({ children }) => {
  const [data, setData] = useState({});
  const [step, setStep] = useState(1);
  const [activeTab, setActiveTab] = useState(1);
  const [cookie] = useCookies();
  const [searchParams] = useSearchParams();
  const axiosConfig = useAxiosConfigGlobal();
  const navigate = useNavigate();
  const axiosHeader = {
    headers: {
      Accept: "application/json",
      Authorization:
        "Bearer " + (searchParams.get("access_token") ?? cookie.mmusic_token),
    },
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          distributionUrl + "panel-api/oauth/current",
          axiosHeader
        );
        const fetchedData = response.data.data;
        setData(fetchedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const submitData = async (data) => {
    try {
      const res = await axios.put(
        distributionUrl + "panel-api/oauth/agreement",
        data,
        axiosConfig
      );

      if (res.status === 200) {
        setTimeout(() => {
          navigate("/");
        }, 2000);
      }
    } catch (err) {
      let errorMessage = "Алдаа гарлаа. Дахин оролдоно уу.";

      if (err instanceof AxiosError) {
        const errorData = err.response?.data;
        if (errorData?.errors) {
          errorMessage = Object.values(errorData.errors).flat().join("\n");
        } else {
          errorMessage = err.message;
        }
      }

      console.error("Error:", errorMessage);
    }
  };

  const handleNext = () => {
    setStep((prev) => (prev < maxStep ? prev + 1 : prev));
  };

  const handlePrevious = () => {
    setStep((prev) => (prev > 1 ? prev - 1 : prev));
  };

  const handleDataChange = (values) => {
    setData((prev) => ({
      ...prev,
      ...values,
    }));
  };

  return (
    <ContractContext.Provider
      value={{
        data,
        setData,
        step,
        setStep,
        updateStep: setStep,
        handleNext,
        handlePrevious,
        handleDataChange,
        activeTab,
        setActiveTab,
        submitData,
      }}
    >
      {children}
    </ContractContext.Provider>
  );
};
